/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCustomerMessage = /* GraphQL */ `
  query GetCustomerMessage($id: ID!) {
    getCustomerMessage(id: $id) {
      id
      name
      email
      phone
      subject
      message
      services
      attachmentKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCustomerMessages = /* GraphQL */ `
  query ListCustomerMessages(
    $filter: ModelCustomerMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        phone
        subject
        message
        services
        attachmentKeys
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGalleryItem = /* GraphQL */ `
  query GetGalleryItem($id: ID!) {
    getGalleryItem(id: $id) {
      id
      description
      facebookLink
      instagramLink
      imageKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGalleryItems = /* GraphQL */ `
  query ListGalleryItems(
    $filter: ModelGalleryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGalleryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        description
        facebookLink
        instagramLink
        imageKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
